// @core/api/endpoints/product/create_product_profile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateProductProfileRequest,
  ProductProfileResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Create profile in product (first access)
 * Creates the user's initial profile when accessing a product for the first time. Establishes the user's identity within the product context.
 */
export async function CreateProductProfile(
  product_id: string,
  data: CreateProductProfileRequest,
  options?: RequestOptions
): Promise<ProductProfileResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/profile`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<ProductProfileResponse>(requestPath, data, requestOptions);
}
